import React from 'react'
import Heading from './Heading'
import Project from './Project'
import './Projects.css'
import projects from './projects.json'

function Projects() {
  return (
    <div className='projects'>
      <Heading title='featured projects' />
      <div className='projects__container'>
        {projects.map(({ img, title, info, link, github }) => (
          <Project
            img={img}
            title={title}
            info={info}
            link={link}
            github={github}
          />
        ))}
      </div>
    </div>
  )
}

export default Projects
